<template>
  <div class="chip" :class="{ 'chip-filtered': !!filter }" @click="$emit('click')">
    <slot>Label</slot>
    <span v-if="filter" class="filter" :style="{ 'max-width': `${filterLabelWidth}px`}">
      {{ filter }}
    </span>
    <span v-else-if="noFilterLabel" class="filter">
      {{ noFilterLabel }}
    </span>
    <span v-if="$attrs['aria-haspopup']" class="caret"></span>
    <i @click.stop.prevent="$emit('close')" class="fa fal fa-times icon-close"></i>
  </div>
</template>

<script>
export default {
  name: 'i-chip',
  props: {
    filter: {
      type: String,
    },
    noFilterLabel: {
      type: String,
    },
    filterLabelWidth: {
      type: Number,
      default: 90,
    },
  },
};
</script>

<style lang="scss" scoped>
.chip {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: $blue;
  border-radius: 2px;
  border: 1px solid $blue;
  padding: 6px 12px;
  max-height: 32px;
  outline: 0;
  font-size: 13px;
}
.chip:hover {
  background-color: $ibutton-bg-hover-color-light;
}
.chip:focus {
  background-color: $ibutton-bg-hover-color-light !important;
}
.chip.chip-filtered {
  background-color: $i-list-selected-bg
}
.icon-close, .caret {
  margin-left: 7px;
}
.filter {
  max-width: 90px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.filter::before {
  content: ': ';
}
</style>
